<template>
  <div>
    <el-table v-loading="loading" border :data="tableData" height="calc(100% - 20px)" size="mini">
      <slot></slot>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSizez"
      layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
  </div>
</template>

<script>

export default {
  data () {
    return {
      tableData: [],
      currentPage: 1,
      loading: true,
      total: 0,
      pageSizes: [10, 18, 19, 20, 30, 40, 50, 60, 70, 80, 90, 100, 150, 200],
      pageSizez: this.pageSize
    }
  },
  name: "sTable",
  props: {
    url: "",
    search: "",
    keys: "",
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pageSize: {
      type: Number,
      default: function () {
        return 20
      }
    }
  },
  watch: { // 加个监听的，，防止父级数据改变，子组件没有跟着改变
    search: {
      handler (val, oldVal) {
        if (oldVal==undefined) return
        var that = this
        this.search = val
        this.yemian(1)
      },
      deep: true,
      immediate: true
    },
    keys: {
      handler (val, oldVal) {
        if (oldVal==undefined) return
        var that = this
        this.keys = val
        this.yemian(2)
      },
      deep: true,
      immediate: true
    }
  },
  created: function () {
    this.yemian()
  },
  computed: {
    computedTxt: function (e) {
      return ""
    }
  },
  methods: {
    handleSizeChange (val) {
      this.pageSizez = val
      this.yemian()
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.yemian()
    },

    yemian () {
      if (this.url != undefined) {
        this.data.currentPage = this.currentPage
        this.data.pageSize = this.pageSizez
        this.data.search = this.search
        this.data.keys = this.keys
        this.data.token = this.$store.getters.getTokenValue
        this.loading = true
        this.sApi(this.url, this.data).then(res => {
          this.tableData = res.data
          this.loading = false
          this.total = res.count * 1
        })
      }
    }
  }
};
</script>

<style scoped>
.el-table {
  width: 100%;
}

.el-pagination {
  margin-top: 10px;
}
</style>
<style>
.head_pic {
  display: block;
}
</style>
